export const DIRECT_MESSAGE_OPEN_EVENT = "xima:open-direct-message";
export const DIRECT_MESSAGE_UNREAD_EVENT = "xima:direct-message-unread";
export const DIRECT_MESSAGE_UNREAD_GLOBAL_KEY = "__ximaDirectMessageUnreadSummary";

const normalizeCount = (value) => Math.max(0, Math.floor(Number(value) || 0));

export const canShowConnectedPlayerMessage = (player, currentPlayerCode = "") => {
  const playerCode = String(player?.publicId || player?.playerCode || "")
    .trim()
    .toUpperCase();
  const ownPlayerCode = String(currentPlayerCode || "").trim().toUpperCase();
  return Boolean(playerCode && player?.canReceiveMessages && playerCode !== ownPlayerCode);
};

export const getConversationAttentionCount = (conversation) => {
  if (!conversation || typeof conversation !== "object") return 0;
  const unreadCount = normalizeCount(conversation.unreadCount);
  const isPendingRecipient =
    String(conversation.status || "") === "pending" &&
    String(conversation.viewerRole || "") === "recipient";
  return isPendingRecipient ? Math.max(1, unreadCount) : unreadCount;
};

export const buildDirectMessageUnreadSummary = (conversations) => {
  const byPlayerCode = {};
  let total = 0;

  (Array.isArray(conversations) ? conversations : []).forEach((conversation) => {
    const count = getConversationAttentionCount(conversation);
    if (!count) return;
    total += count;
    const playerCode = String(
      conversation?.otherPlayer?.publicId || conversation?.otherPlayer?.playerCode || ""
    ).trim();
    if (playerCode) {
      byPlayerCode[playerCode] = normalizeCount(byPlayerCode[playerCode]) + count;
    }
  });

  return { total, byPlayerCode };
};

export const readPublishedDirectMessageUnreadSummary = () => {
  if (typeof window === "undefined") return { total: 0, byPlayerCode: {} };
  const value = window[DIRECT_MESSAGE_UNREAD_GLOBAL_KEY];
  if (!value || typeof value !== "object") return { total: 0, byPlayerCode: {} };
  return {
    total: normalizeCount(value.total),
    byPlayerCode:
      value.byPlayerCode && typeof value.byPlayerCode === "object"
        ? { ...value.byPlayerCode }
        : {},
  };
};
